export default __webpack_public_path__ + "static/media/geology-saturn.b309827a.png";